import { FC, useEffect, useRef, useState } from "react";
import landing1 from "../../../../resources/landing/1.jpg";
import landing2 from "../../../../resources/landing/2.jpg";
import landing3 from "../../../../resources/landing/3.jpg";
import { AnimatePresence, motion } from "framer-motion";

export const AuthAnimatedBackground: FC = () => {
  const intervalRef = useRef<NodeJS.Timeout | undefined>();
  const landingImages = [
    landing1,
    landing2,
    landing3,
  ];
  const [currentLandingImg, setCurrentLandingImg] = useState(landing1);

  /*eslint-disable*/
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrentLandingImg(
        (prev) =>
          landingImages[
            (landingImages.indexOf(prev) + 1) % landingImages.length
          ]
      );
    }, 5000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  return (
    <AnimatePresence>
      <motion.img
        className={"object-cover h-full w-full z-30 absolute inset-0"}
        key={currentLandingImg}
        src={currentLandingImg}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          opacity: {
            duration: 2,
          },
          scale: {
            duration: 2,
          },
        }}
      />
    </AnimatePresence>
  );
};
